// Pauses any playing video in the gallery when the visitor switches to another slide.
class XpAudGallery extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
      this.querySelectorAll('[data-aud-slide]').forEach((slide) => {
        if (slide.dataset.audSlide === input.id) return;
        slide.querySelectorAll('video').forEach((video) => video.pause());
      });
    }, { signal: this.abort.signal });
  }

  disconnectedCallback() {
    this.abort?.abort();
  }
}

if (!customElements.get('xp-aud-gallery')) customElements.define('xp-aud-gallery', XpAudGallery);
